// extracted by mini-css-extract-plugin
export default {"container":"styles_container__aTnCj","logo":"styles_logo__TkD3U"};